import { addGetVersionToWindow } from "@payair/e-com-common-sdk/core/BaseEcomSdk";
import { GooglePaySdkImpl } from "./core/GooglePaySdk";
import { GooglePayButtonColorEnumsObj } from "./enums/GooglePayButtonColorEnum";
import { GooglePayButtonSizeModeEnumsObj } from "./enums/GooglePayButtonSizeModeEnum";
import { GooglePayButtonTypeEnumsObj } from "./enums/GooglePayButtonTypeEnum";
import { GooglePayEventListenerEnumsObj } from "./enums/GooglePayEventListenerEnum";
import { GooglePayEventTypeEnumsObj } from "./enums/GooglePayEventTypeEnum";
/** @internal */ var MAIN_OBJECT_NAME = "payairGooglePay";
/** @internal */ var SDK_OBJECT_NAME = "googlePaySdk";
var googlePaySdk = new GooglePaySdkImpl();
/*
  NOTE
  Added getVersion to window always. If user uses JS file, the object will be overwritten with proper getVersion,
  otherwise if using NPM this object will stay in the window object.
*/
/** @internal */ addGetVersionToWindow(MAIN_OBJECT_NAME, SDK_OBJECT_NAME, googlePaySdk.getVersion);
var payairGooglePay = {
    googlePaySdk: googlePaySdk,
    GooglePayEventListenerEnums: GooglePayEventListenerEnumsObj,
    GooglePayEventTypeEnums: GooglePayEventTypeEnumsObj,
    GooglePayButtonColorEnums: GooglePayButtonColorEnumsObj,
    GooglePayButtonSizeModeEnums: GooglePayButtonSizeModeEnumsObj,
    GooglePayButtonTypeEnums: GooglePayButtonTypeEnumsObj,
};
export default payairGooglePay;
